export default function menuOpen() {
    const burger = document.getElementById('ds-burger');
    const head = document.getElementById('ds-head');

    if (!burger || !head) return;

    burger.addEventListener('click', () => {
        const isOpen = head.classList.toggle('is-head-open');
        burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        burger.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
        document.body.classList.toggle('is-menu-open', isOpen);
    });

    head.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
            head.classList.remove('is-head-open');
            burger.setAttribute('aria-expanded', 'false');
            burger.setAttribute('aria-label', 'Ouvrir le menu');
            document.body.classList.remove('is-menu-open');
        });
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && head.classList.contains('is-head-open')) {
            head.classList.remove('is-head-open');
            burger.setAttribute('aria-expanded', 'false');
            burger.setAttribute('aria-label', 'Ouvrir le menu');
            document.body.classList.remove('is-menu-open');
        }
    });
}
